import * as z from "zod";
import { gql } from "graphql-request";

import { Sys, SysFragment } from "./sys";
import { Targeting, TargetingFragment } from "./targeting";
import { RelatedMedia, RelatedMediaFragment } from "./relatedMedia";
import {
  LocalizedSpotlight,
  LocalizedSpotlightFragment,
} from "./newsEntryTypes/localizedSpotlight";
import {
  CarouselEventPollEntry,
  CarouselEventPollEntryFragment,
} from "./newsEntryTypes/carouselEventPollEntry";
import {
  CarouselEventProgressTrackerEntry,
  CarouselEventProgressTrackerEntryFragment,
} from "./newsEntryTypes/carouselEventProgressTrackerEntry";
import {
  EsportCarouselLiveEntry,
  EsportCarouselLiveEntryFragment,
} from "./newsEntryTypes/esportCarouselLiveEntry";

export const EsportSpotlight = z.object({
  __typename: z.literal("EsportSpotlight"),
  sys: Sys,
  sortDate: z.string().nullable(),
  newUntil: z.string().nullable(),
  size: z.enum(["small", "medium", "large"]).nullable(),
  video: z.string().nullable(),
  enableVideoSound: z.boolean().nullable().default(false),
  targeting: Targeting.nullable(),
  relatedMedia: RelatedMedia.nullable(),
  localized: z
    .discriminatedUnion("__typename", [
      EsportCarouselLiveEntry,
      LocalizedSpotlight,
      CarouselEventPollEntry,
      CarouselEventProgressTrackerEntry,
    ])
    .nullish(),
});

export type EsportSpotlight = z.infer<typeof EsportSpotlight>;

export const EsportSpotlightFragment = gql`
  fragment EsportSpotlightFragment on EsportSpotlight {
    __typename
    sys {
      ...SysFragment
    }
    targeting {
      ...TargetingFragment
    }
    relatedMedia {
      ...RelatedMediaFragment
    }
    newUntil
    sortDate
    size
    video
    enableVideoSound
    localized {
      ... on EsportLiveEventEntry {
        ...EsportCarouselLiveEntryFragment
      }
      ... on LocalizedSpotlight {
        ...LocalizedSpotlightFragment
      }
      ... on CarouselEventPollEntry {
        ...CarouselEventPollEntryFragment
      }
      ... on CarouselEventProgressTrackerEntry {
        ...CarouselEventProgressTrackerEntryFragment
      }
    }
  }
  ${SysFragment}
  ${EsportCarouselLiveEntryFragment}
  ${LocalizedSpotlightFragment}
  ${CarouselEventPollEntryFragment}
  ${CarouselEventProgressTrackerEntryFragment}
  ${TargetingFragment}
  ${RelatedMediaFragment}
`;
